import { combineReducers } from 'redux';

import byPage from './byPage/reducer';
import byKeyMaker from 'reducersMakers/byKeyMaker';

export default byKeyMaker('searchQueryString', combineReducers({ byPage }));



/** WEBPACK FOOTER **
 ** ./src/members/state/search/results/byQuery/reducer.js
 **/